import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";

var root = $.from_html(`<div class="slex-hero-eyebrow"> </div>`);
var root_1 = $.from_html(`<h1 class="slex-hero-title"> </h1>`);
var root_2 = $.from_html(`<p class="slex-hero-subtitle"> </p>`);
var root_3 = $.from_html(`<a class="slex-hero-action slex-hero-action--primary"> </a>`);
var root_4 = $.from_html(`<a class="slex-hero-action slex-hero-action--secondary"> </a>`);
var root_5 = $.from_html(`<div class="slex-hero-actions"><!> <!></div>`);
var root_6 = $.from_html(`<section class="slex-hero"><div class="slex-hero-copy"><!> <!> <!> <!></div> <div class="slex-hero-media"></div></section>`);

export default function Hero($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var section = root_6();
	var div = $.child(section);
	var node = $.child(div);

	{
		var consequent = ($$anchor) => {
			var div_1 = root();
			var text_1 = $.child(div_1, true);

			$.reset(div_1);
			$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).eyebrow)]);
			$.append($$anchor, div_1);
		};

		$.if(node, ($$render) => {
			if ($.get(p).eyebrow) $$render(consequent);
		});
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_1 = ($$anchor) => {
			var h1 = root_1();
			var text_2 = $.child(h1, true);

			$.reset(h1);
			$.template_effect(($0) => $.set_text(text_2, $0), [() => text($.get(p).title)]);
			$.append($$anchor, h1);
		};

		$.if(node_1, ($$render) => {
			if ($.get(p).title) $$render(consequent_1);
		});
	}

	var node_2 = $.sibling(node_1, 2);

	{
		var consequent_2 = ($$anchor) => {
			var p_1 = root_2();
			var text_3 = $.child(p_1, true);

			$.reset(p_1);
			$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(p).subtitle)]);
			$.append($$anchor, p_1);
		};

		$.if(node_2, ($$render) => {
			if ($.get(p).subtitle) $$render(consequent_2);
		});
	}

	var node_3 = $.sibling(node_2, 2);

	{
		var consequent_5 = ($$anchor) => {
			var div_2 = root_5();
			var node_4 = $.child(div_2);

			{
				var consequent_3 = ($$anchor) => {
					var a = root_3();
					var text_4 = $.child(a, true);

					$.reset(a);

					$.template_effect(
						($0, $1) => {
							$.set_attribute(a, 'href', $0);
							$.set_text(text_4, $1);
						},
						[
							() => text($.get(p).primaryHref, "#"),
							() => text($.get(p).primaryLabel)
						]
					);

					$.append($$anchor, a);
				};

				$.if(node_4, ($$render) => {
					if ($.get(p).primaryLabel) $$render(consequent_3);
				});
			}

			var node_5 = $.sibling(node_4, 2);

			{
				var consequent_4 = ($$anchor) => {
					var a_1 = root_4();
					var text_5 = $.child(a_1, true);

					$.reset(a_1);

					$.template_effect(
						($0, $1) => {
							$.set_attribute(a_1, 'href', $0);
							$.set_text(text_5, $1);
						},
						[
							() => text($.get(p).secondaryHref, "#"),
							() => text($.get(p).secondaryLabel)
						]
					);

					$.append($$anchor, a_1);
				};

				$.if(node_5, ($$render) => {
					if ($.get(p).secondaryLabel) $$render(consequent_4);
				});
			}

			$.reset(div_2);
			$.append($$anchor, div_2);
		};

		$.if(node_3, ($$render) => {
			if ($.get(p).primaryLabel || $.get(p).secondaryLabel) $$render(consequent_5);
		});
	}

	$.reset(div);

	var div_3 = $.sibling(div, 2);

	$.action(div_3, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);
	$.reset(section);
	$.template_effect(() => $.set_attribute(section, 'data-align', $.get(p).align === "center" ? "center" : "split"));
	$.append($$anchor, section);
	$.pop();
}